/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as WelcomeRouteImport } from './routes/welcome';
import { Route as SystemRouteImport } from './routes/system';
import { Route as SettingsRouteImport } from './routes/settings';
import { Route as SearchRouteImport } from './routes/search';
import { Route as GuideRouteImport } from './routes/guide';
import { Route as IndexRouteImport } from './routes/index';
import { Route as SystemIndexRouteImport } from './routes/system/index';
import { Route as Media_sourcesIndexRouteImport } from './routes/media_sources_/index';
import { Route as LibraryIndexRouteImport } from './routes/library/index';
import { Route as ChannelsIndexRouteImport } from './routes/channels_/index';
import { Route as SystemTasksRouteImport } from './routes/system/tasks';
import { Route as SystemLogsRouteImport } from './routes/system/logs';
import { Route as SystemDebugRouteImport } from './routes/system/debug';
import { Route as SettingsXmltvRouteImport } from './routes/settings/xmltv';
import { Route as SettingsSourcesRouteImport } from './routes/settings/sources';
import { Route as SettingsHdhrRouteImport } from './routes/settings/hdhr';
import { Route as SettingsGeneralRouteImport } from './routes/settings/general';
import { Route as SettingsFfmpegRouteImport } from './routes/settings/ffmpeg';
import { Route as LibraryFillersRouteImport } from './routes/library/fillers';
import { Route as LibraryCustomShowsRouteImport } from './routes/library/custom-shows';
import { Route as ChannelsTestRouteImport } from './routes/channels_/test';
import { Route as ChannelsNewRouteImport } from './routes/channels_/new';
import { Route as ChannelsChannelIdRouteRouteImport } from './routes/channels_/$channelId/route';
import { Route as Media_sourcesMediaSourceIdIndexRouteImport } from './routes/media_sources_/$mediaSourceId/index';
import { Route as LibraryTrashIndexRouteImport } from './routes/library/trash_/index';
import { Route as LibrarySmart_collectionsIndexRouteImport } from './routes/library/smart_collections/index';
import { Route as ChannelsChannelIdIndexRouteImport } from './routes/channels_/$channelId/index';
import { Route as SettingsFfmpegNewRouteImport } from './routes/settings/ffmpeg_/new';
import { Route as SettingsFfmpegConfigIdRouteImport } from './routes/settings/ffmpeg_/$configId';
import { Route as MediaProgramTypeProgramIdRouteImport } from './routes/media_/$programType.$programId';
import { Route as LibrarySmart_collectionsIdRouteImport } from './routes/library/smart_collections/$id';
import { Route as ChannelsChannelIdWatchRouteImport } from './routes/channels_/$channelId/watch';
import { Route as LibraryFillersNewRouteRouteImport } from './routes/library/fillers_/new/route';
import { Route as LibraryFillersFillerIdRouteRouteImport } from './routes/library/fillers_/$fillerId/route';
import { Route as LibraryCustomShowsNewRouteRouteImport } from './routes/library/custom-shows_/new/route';
import { Route as LibraryCustomShowsShowIdRouteRouteImport } from './routes/library/custom-shows_/$showId/route';
import { Route as LibraryFillersNewIndexRouteImport } from './routes/library/fillers_/new/index';
import { Route as LibraryCustomShowsNewIndexRouteImport } from './routes/library/custom-shows_/new/index';
import { Route as ChannelsChannelIdProgrammingIndexRouteImport } from './routes/channels_/$channelId/programming/index';
import { Route as ChannelsChannelIdEditIndexRouteImport } from './routes/channels_/$channelId/edit/index';
import { Route as Media_sourcesMediaSourceIdLibrariesLibraryIdRouteImport } from './routes/media_sources_/$mediaSourceId/libraries_.$libraryId';
import { Route as LibraryFillersNewProgrammingRouteImport } from './routes/library/fillers_/new/programming';
import { Route as LibraryFillersFillerIdProgrammingRouteImport } from './routes/library/fillers_/$fillerId/programming';
import { Route as LibraryFillersFillerIdEditRouteImport } from './routes/library/fillers_/$fillerId/edit';
import { Route as LibraryCustomShowsNewProgrammingRouteImport } from './routes/library/custom-shows_/new/programming';
import { Route as LibraryCustomShowsShowIdProgrammingRouteImport } from './routes/library/custom-shows_/$showId/programming';
import { Route as LibraryCustomShowsShowIdEditRouteImport } from './routes/library/custom-shows_/$showId/edit';
import { Route as ChannelsChannelIdProgrammingTimeSlotEditorRouteImport } from './routes/channels_/$channelId/programming/time-slot-editor';
import { Route as ChannelsChannelIdProgrammingSlotEditorRouteImport } from './routes/channels_/$channelId/programming/slot-editor';
import { Route as ChannelsChannelIdProgrammingAddRouteImport } from './routes/channels_/$channelId/programming/add';

const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any);
const SystemRoute = SystemRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any);
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any);
const GuideRoute = GuideRouteImport.update({
  id: '/guide',
  path: '/guide',
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const SystemIndexRoute = SystemIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SystemRoute,
} as any);
const Media_sourcesIndexRoute = Media_sourcesIndexRouteImport.update({
  id: '/media_sources_/',
  path: '/media_sources/',
  getParentRoute: () => rootRouteImport,
} as any);
const LibraryIndexRoute = LibraryIndexRouteImport.update({
  id: '/library/',
  path: '/library/',
  getParentRoute: () => rootRouteImport,
} as any);
const ChannelsIndexRoute = ChannelsIndexRouteImport.update({
  id: '/channels_/',
  path: '/channels/',
  getParentRoute: () => rootRouteImport,
} as any);
const SystemTasksRoute = SystemTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => SystemRoute,
} as any);
const SystemLogsRoute = SystemLogsRouteImport.update({
  id: '/logs',
  path: '/logs',
  getParentRoute: () => SystemRoute,
} as any);
const SystemDebugRoute = SystemDebugRouteImport.update({
  id: '/debug',
  path: '/debug',
  getParentRoute: () => SystemRoute,
} as any);
const SettingsXmltvRoute = SettingsXmltvRouteImport.update({
  id: '/xmltv',
  path: '/xmltv',
  getParentRoute: () => SettingsRoute,
} as any);
const SettingsSourcesRoute = SettingsSourcesRouteImport.update({
  id: '/sources',
  path: '/sources',
  getParentRoute: () => SettingsRoute,
} as any);
const SettingsHdhrRoute = SettingsHdhrRouteImport.update({
  id: '/hdhr',
  path: '/hdhr',
  getParentRoute: () => SettingsRoute,
} as any);
const SettingsGeneralRoute = SettingsGeneralRouteImport.update({
  id: '/general',
  path: '/general',
  getParentRoute: () => SettingsRoute,
} as any);
const SettingsFfmpegRoute = SettingsFfmpegRouteImport.update({
  id: '/ffmpeg',
  path: '/ffmpeg',
  getParentRoute: () => SettingsRoute,
} as any);
const LibraryFillersRoute = LibraryFillersRouteImport.update({
  id: '/library/fillers',
  path: '/library/fillers',
  getParentRoute: () => rootRouteImport,
} as any);
const LibraryCustomShowsRoute = LibraryCustomShowsRouteImport.update({
  id: '/library/custom-shows',
  path: '/library/custom-shows',
  getParentRoute: () => rootRouteImport,
} as any);
const ChannelsTestRoute = ChannelsTestRouteImport.update({
  id: '/channels_/test',
  path: '/channels/test',
  getParentRoute: () => rootRouteImport,
} as any);
const ChannelsNewRoute = ChannelsNewRouteImport.update({
  id: '/channels_/new',
  path: '/channels/new',
  getParentRoute: () => rootRouteImport,
} as any);
const ChannelsChannelIdRouteRoute = ChannelsChannelIdRouteRouteImport.update({
  id: '/channels_/$channelId',
  path: '/channels/$channelId',
  getParentRoute: () => rootRouteImport,
} as any);
const Media_sourcesMediaSourceIdIndexRoute =
  Media_sourcesMediaSourceIdIndexRouteImport.update({
    id: '/media_sources_/$mediaSourceId/',
    path: '/media_sources/$mediaSourceId/',
    getParentRoute: () => rootRouteImport,
  } as any);
const LibraryTrashIndexRoute = LibraryTrashIndexRouteImport.update({
  id: '/library/trash_/',
  path: '/library/trash/',
  getParentRoute: () => rootRouteImport,
} as any);
const LibrarySmart_collectionsIndexRoute =
  LibrarySmart_collectionsIndexRouteImport.update({
    id: '/library/smart_collections/',
    path: '/library/smart_collections/',
    getParentRoute: () => rootRouteImport,
  } as any);
const ChannelsChannelIdIndexRoute = ChannelsChannelIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ChannelsChannelIdRouteRoute,
} as any);
const SettingsFfmpegNewRoute = SettingsFfmpegNewRouteImport.update({
  id: '/ffmpeg_/new',
  path: '/ffmpeg/new',
  getParentRoute: () => SettingsRoute,
} as any);
const SettingsFfmpegConfigIdRoute = SettingsFfmpegConfigIdRouteImport.update({
  id: '/ffmpeg_/$configId',
  path: '/ffmpeg/$configId',
  getParentRoute: () => SettingsRoute,
} as any);
const MediaProgramTypeProgramIdRoute =
  MediaProgramTypeProgramIdRouteImport.update({
    id: '/media_/$programType/$programId',
    path: '/media/$programType/$programId',
    getParentRoute: () => rootRouteImport,
  } as any);
const LibrarySmart_collectionsIdRoute =
  LibrarySmart_collectionsIdRouteImport.update({
    id: '/library/smart_collections/$id',
    path: '/library/smart_collections/$id',
    getParentRoute: () => rootRouteImport,
  } as any);
const ChannelsChannelIdWatchRoute = ChannelsChannelIdWatchRouteImport.update({
  id: '/watch',
  path: '/watch',
  getParentRoute: () => ChannelsChannelIdRouteRoute,
} as any);
const LibraryFillersNewRouteRoute = LibraryFillersNewRouteRouteImport.update({
  id: '/library/fillers_/new',
  path: '/library/fillers/new',
  getParentRoute: () => rootRouteImport,
} as any);
const LibraryFillersFillerIdRouteRoute =
  LibraryFillersFillerIdRouteRouteImport.update({
    id: '/library/fillers_/$fillerId',
    path: '/library/fillers/$fillerId',
    getParentRoute: () => rootRouteImport,
  } as any);
const LibraryCustomShowsNewRouteRoute =
  LibraryCustomShowsNewRouteRouteImport.update({
    id: '/library/custom-shows_/new',
    path: '/library/custom-shows/new',
    getParentRoute: () => rootRouteImport,
  } as any);
const LibraryCustomShowsShowIdRouteRoute =
  LibraryCustomShowsShowIdRouteRouteImport.update({
    id: '/library/custom-shows_/$showId',
    path: '/library/custom-shows/$showId',
    getParentRoute: () => rootRouteImport,
  } as any);
const LibraryFillersNewIndexRoute = LibraryFillersNewIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LibraryFillersNewRouteRoute,
} as any);
const LibraryCustomShowsNewIndexRoute =
  LibraryCustomShowsNewIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LibraryCustomShowsNewRouteRoute,
  } as any);
const ChannelsChannelIdProgrammingIndexRoute =
  ChannelsChannelIdProgrammingIndexRouteImport.update({
    id: '/programming/',
    path: '/programming/',
    getParentRoute: () => ChannelsChannelIdRouteRoute,
  } as any);
const ChannelsChannelIdEditIndexRoute =
  ChannelsChannelIdEditIndexRouteImport.update({
    id: '/edit/',
    path: '/edit/',
    getParentRoute: () => ChannelsChannelIdRouteRoute,
  } as any);
const Media_sourcesMediaSourceIdLibrariesLibraryIdRoute =
  Media_sourcesMediaSourceIdLibrariesLibraryIdRouteImport.update({
    id: '/media_sources_/$mediaSourceId/libraries_/$libraryId',
    path: '/media_sources/$mediaSourceId/libraries/$libraryId',
    getParentRoute: () => rootRouteImport,
  } as any);
const LibraryFillersNewProgrammingRoute =
  LibraryFillersNewProgrammingRouteImport.update({
    id: '/programming',
    path: '/programming',
    getParentRoute: () => LibraryFillersNewRouteRoute,
  } as any);
const LibraryFillersFillerIdProgrammingRoute =
  LibraryFillersFillerIdProgrammingRouteImport.update({
    id: '/programming',
    path: '/programming',
    getParentRoute: () => LibraryFillersFillerIdRouteRoute,
  } as any);
const LibraryFillersFillerIdEditRoute =
  LibraryFillersFillerIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => LibraryFillersFillerIdRouteRoute,
  } as any);
const LibraryCustomShowsNewProgrammingRoute =
  LibraryCustomShowsNewProgrammingRouteImport.update({
    id: '/programming',
    path: '/programming',
    getParentRoute: () => LibraryCustomShowsNewRouteRoute,
  } as any);
const LibraryCustomShowsShowIdProgrammingRoute =
  LibraryCustomShowsShowIdProgrammingRouteImport.update({
    id: '/programming',
    path: '/programming',
    getParentRoute: () => LibraryCustomShowsShowIdRouteRoute,
  } as any);
const LibraryCustomShowsShowIdEditRoute =
  LibraryCustomShowsShowIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => LibraryCustomShowsShowIdRouteRoute,
  } as any);
const ChannelsChannelIdProgrammingTimeSlotEditorRoute =
  ChannelsChannelIdProgrammingTimeSlotEditorRouteImport.update({
    id: '/programming/time-slot-editor',
    path: '/programming/time-slot-editor',
    getParentRoute: () => ChannelsChannelIdRouteRoute,
  } as any);
const ChannelsChannelIdProgrammingSlotEditorRoute =
  ChannelsChannelIdProgrammingSlotEditorRouteImport.update({
    id: '/programming/slot-editor',
    path: '/programming/slot-editor',
    getParentRoute: () => ChannelsChannelIdRouteRoute,
  } as any);
const ChannelsChannelIdProgrammingAddRoute =
  ChannelsChannelIdProgrammingAddRouteImport.update({
    id: '/programming/add',
    path: '/programming/add',
    getParentRoute: () => ChannelsChannelIdRouteRoute,
  } as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/guide': typeof GuideRoute;
  '/search': typeof SearchRoute;
  '/settings': typeof SettingsRouteWithChildren;
  '/system': typeof SystemRouteWithChildren;
  '/welcome': typeof WelcomeRoute;
  '/channels/$channelId': typeof ChannelsChannelIdRouteRouteWithChildren;
  '/channels/new': typeof ChannelsNewRoute;
  '/channels/test': typeof ChannelsTestRoute;
  '/library/custom-shows': typeof LibraryCustomShowsRoute;
  '/library/fillers': typeof LibraryFillersRoute;
  '/settings/ffmpeg': typeof SettingsFfmpegRoute;
  '/settings/general': typeof SettingsGeneralRoute;
  '/settings/hdhr': typeof SettingsHdhrRoute;
  '/settings/sources': typeof SettingsSourcesRoute;
  '/settings/xmltv': typeof SettingsXmltvRoute;
  '/system/debug': typeof SystemDebugRoute;
  '/system/logs': typeof SystemLogsRoute;
  '/system/tasks': typeof SystemTasksRoute;
  '/channels': typeof ChannelsIndexRoute;
  '/library': typeof LibraryIndexRoute;
  '/media_sources': typeof Media_sourcesIndexRoute;
  '/system/': typeof SystemIndexRoute;
  '/library/custom-shows/$showId': typeof LibraryCustomShowsShowIdRouteRouteWithChildren;
  '/library/custom-shows/new': typeof LibraryCustomShowsNewRouteRouteWithChildren;
  '/library/fillers/$fillerId': typeof LibraryFillersFillerIdRouteRouteWithChildren;
  '/library/fillers/new': typeof LibraryFillersNewRouteRouteWithChildren;
  '/channels/$channelId/watch': typeof ChannelsChannelIdWatchRoute;
  '/library/smart_collections/$id': typeof LibrarySmart_collectionsIdRoute;
  '/media/$programType/$programId': typeof MediaProgramTypeProgramIdRoute;
  '/settings/ffmpeg/$configId': typeof SettingsFfmpegConfigIdRoute;
  '/settings/ffmpeg/new': typeof SettingsFfmpegNewRoute;
  '/channels/$channelId/': typeof ChannelsChannelIdIndexRoute;
  '/library/smart_collections': typeof LibrarySmart_collectionsIndexRoute;
  '/library/trash': typeof LibraryTrashIndexRoute;
  '/media_sources/$mediaSourceId': typeof Media_sourcesMediaSourceIdIndexRoute;
  '/channels/$channelId/programming/add': typeof ChannelsChannelIdProgrammingAddRoute;
  '/channels/$channelId/programming/slot-editor': typeof ChannelsChannelIdProgrammingSlotEditorRoute;
  '/channels/$channelId/programming/time-slot-editor': typeof ChannelsChannelIdProgrammingTimeSlotEditorRoute;
  '/library/custom-shows/$showId/edit': typeof LibraryCustomShowsShowIdEditRoute;
  '/library/custom-shows/$showId/programming': typeof LibraryCustomShowsShowIdProgrammingRoute;
  '/library/custom-shows/new/programming': typeof LibraryCustomShowsNewProgrammingRoute;
  '/library/fillers/$fillerId/edit': typeof LibraryFillersFillerIdEditRoute;
  '/library/fillers/$fillerId/programming': typeof LibraryFillersFillerIdProgrammingRoute;
  '/library/fillers/new/programming': typeof LibraryFillersNewProgrammingRoute;
  '/media_sources/$mediaSourceId/libraries/$libraryId': typeof Media_sourcesMediaSourceIdLibrariesLibraryIdRoute;
  '/channels/$channelId/edit': typeof ChannelsChannelIdEditIndexRoute;
  '/channels/$channelId/programming': typeof ChannelsChannelIdProgrammingIndexRoute;
  '/library/custom-shows/new/': typeof LibraryCustomShowsNewIndexRoute;
  '/library/fillers/new/': typeof LibraryFillersNewIndexRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/guide': typeof GuideRoute;
  '/search': typeof SearchRoute;
  '/settings': typeof SettingsRouteWithChildren;
  '/welcome': typeof WelcomeRoute;
  '/channels/new': typeof ChannelsNewRoute;
  '/channels/test': typeof ChannelsTestRoute;
  '/library/custom-shows': typeof LibraryCustomShowsRoute;
  '/library/fillers': typeof LibraryFillersRoute;
  '/settings/ffmpeg': typeof SettingsFfmpegRoute;
  '/settings/general': typeof SettingsGeneralRoute;
  '/settings/hdhr': typeof SettingsHdhrRoute;
  '/settings/sources': typeof SettingsSourcesRoute;
  '/settings/xmltv': typeof SettingsXmltvRoute;
  '/system/debug': typeof SystemDebugRoute;
  '/system/logs': typeof SystemLogsRoute;
  '/system/tasks': typeof SystemTasksRoute;
  '/channels': typeof ChannelsIndexRoute;
  '/library': typeof LibraryIndexRoute;
  '/media_sources': typeof Media_sourcesIndexRoute;
  '/system': typeof SystemIndexRoute;
  '/library/custom-shows/$showId': typeof LibraryCustomShowsShowIdRouteRouteWithChildren;
  '/library/fillers/$fillerId': typeof LibraryFillersFillerIdRouteRouteWithChildren;
  '/channels/$channelId/watch': typeof ChannelsChannelIdWatchRoute;
  '/library/smart_collections/$id': typeof LibrarySmart_collectionsIdRoute;
  '/media/$programType/$programId': typeof MediaProgramTypeProgramIdRoute;
  '/settings/ffmpeg/$configId': typeof SettingsFfmpegConfigIdRoute;
  '/settings/ffmpeg/new': typeof SettingsFfmpegNewRoute;
  '/channels/$channelId': typeof ChannelsChannelIdIndexRoute;
  '/library/smart_collections': typeof LibrarySmart_collectionsIndexRoute;
  '/library/trash': typeof LibraryTrashIndexRoute;
  '/media_sources/$mediaSourceId': typeof Media_sourcesMediaSourceIdIndexRoute;
  '/channels/$channelId/programming/add': typeof ChannelsChannelIdProgrammingAddRoute;
  '/channels/$channelId/programming/slot-editor': typeof ChannelsChannelIdProgrammingSlotEditorRoute;
  '/channels/$channelId/programming/time-slot-editor': typeof ChannelsChannelIdProgrammingTimeSlotEditorRoute;
  '/library/custom-shows/$showId/edit': typeof LibraryCustomShowsShowIdEditRoute;
  '/library/custom-shows/$showId/programming': typeof LibraryCustomShowsShowIdProgrammingRoute;
  '/library/custom-shows/new/programming': typeof LibraryCustomShowsNewProgrammingRoute;
  '/library/fillers/$fillerId/edit': typeof LibraryFillersFillerIdEditRoute;
  '/library/fillers/$fillerId/programming': typeof LibraryFillersFillerIdProgrammingRoute;
  '/library/fillers/new/programming': typeof LibraryFillersNewProgrammingRoute;
  '/media_sources/$mediaSourceId/libraries/$libraryId': typeof Media_sourcesMediaSourceIdLibrariesLibraryIdRoute;
  '/channels/$channelId/edit': typeof ChannelsChannelIdEditIndexRoute;
  '/channels/$channelId/programming': typeof ChannelsChannelIdProgrammingIndexRoute;
  '/library/custom-shows/new': typeof LibraryCustomShowsNewIndexRoute;
  '/library/fillers/new': typeof LibraryFillersNewIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/guide': typeof GuideRoute;
  '/search': typeof SearchRoute;
  '/settings': typeof SettingsRouteWithChildren;
  '/system': typeof SystemRouteWithChildren;
  '/welcome': typeof WelcomeRoute;
  '/channels_/$channelId': typeof ChannelsChannelIdRouteRouteWithChildren;
  '/channels_/new': typeof ChannelsNewRoute;
  '/channels_/test': typeof ChannelsTestRoute;
  '/library/custom-shows': typeof LibraryCustomShowsRoute;
  '/library/fillers': typeof LibraryFillersRoute;
  '/settings/ffmpeg': typeof SettingsFfmpegRoute;
  '/settings/general': typeof SettingsGeneralRoute;
  '/settings/hdhr': typeof SettingsHdhrRoute;
  '/settings/sources': typeof SettingsSourcesRoute;
  '/settings/xmltv': typeof SettingsXmltvRoute;
  '/system/debug': typeof SystemDebugRoute;
  '/system/logs': typeof SystemLogsRoute;
  '/system/tasks': typeof SystemTasksRoute;
  '/channels_/': typeof ChannelsIndexRoute;
  '/library/': typeof LibraryIndexRoute;
  '/media_sources_/': typeof Media_sourcesIndexRoute;
  '/system/': typeof SystemIndexRoute;
  '/library/custom-shows_/$showId': typeof LibraryCustomShowsShowIdRouteRouteWithChildren;
  '/library/custom-shows_/new': typeof LibraryCustomShowsNewRouteRouteWithChildren;
  '/library/fillers_/$fillerId': typeof LibraryFillersFillerIdRouteRouteWithChildren;
  '/library/fillers_/new': typeof LibraryFillersNewRouteRouteWithChildren;
  '/channels_/$channelId/watch': typeof ChannelsChannelIdWatchRoute;
  '/library/smart_collections/$id': typeof LibrarySmart_collectionsIdRoute;
  '/media_/$programType/$programId': typeof MediaProgramTypeProgramIdRoute;
  '/settings/ffmpeg_/$configId': typeof SettingsFfmpegConfigIdRoute;
  '/settings/ffmpeg_/new': typeof SettingsFfmpegNewRoute;
  '/channels_/$channelId/': typeof ChannelsChannelIdIndexRoute;
  '/library/smart_collections/': typeof LibrarySmart_collectionsIndexRoute;
  '/library/trash_/': typeof LibraryTrashIndexRoute;
  '/media_sources_/$mediaSourceId/': typeof Media_sourcesMediaSourceIdIndexRoute;
  '/channels_/$channelId/programming/add': typeof ChannelsChannelIdProgrammingAddRoute;
  '/channels_/$channelId/programming/slot-editor': typeof ChannelsChannelIdProgrammingSlotEditorRoute;
  '/channels_/$channelId/programming/time-slot-editor': typeof ChannelsChannelIdProgrammingTimeSlotEditorRoute;
  '/library/custom-shows_/$showId/edit': typeof LibraryCustomShowsShowIdEditRoute;
  '/library/custom-shows_/$showId/programming': typeof LibraryCustomShowsShowIdProgrammingRoute;
  '/library/custom-shows_/new/programming': typeof LibraryCustomShowsNewProgrammingRoute;
  '/library/fillers_/$fillerId/edit': typeof LibraryFillersFillerIdEditRoute;
  '/library/fillers_/$fillerId/programming': typeof LibraryFillersFillerIdProgrammingRoute;
  '/library/fillers_/new/programming': typeof LibraryFillersNewProgrammingRoute;
  '/media_sources_/$mediaSourceId/libraries_/$libraryId': typeof Media_sourcesMediaSourceIdLibrariesLibraryIdRoute;
  '/channels_/$channelId/edit/': typeof ChannelsChannelIdEditIndexRoute;
  '/channels_/$channelId/programming/': typeof ChannelsChannelIdProgrammingIndexRoute;
  '/library/custom-shows_/new/': typeof LibraryCustomShowsNewIndexRoute;
  '/library/fillers_/new/': typeof LibraryFillersNewIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/guide'
    | '/search'
    | '/settings'
    | '/system'
    | '/welcome'
    | '/channels/$channelId'
    | '/channels/new'
    | '/channels/test'
    | '/library/custom-shows'
    | '/library/fillers'
    | '/settings/ffmpeg'
    | '/settings/general'
    | '/settings/hdhr'
    | '/settings/sources'
    | '/settings/xmltv'
    | '/system/debug'
    | '/system/logs'
    | '/system/tasks'
    | '/channels'
    | '/library'
    | '/media_sources'
    | '/system/'
    | '/library/custom-shows/$showId'
    | '/library/custom-shows/new'
    | '/library/fillers/$fillerId'
    | '/library/fillers/new'
    | '/channels/$channelId/watch'
    | '/library/smart_collections/$id'
    | '/media/$programType/$programId'
    | '/settings/ffmpeg/$configId'
    | '/settings/ffmpeg/new'
    | '/channels/$channelId/'
    | '/library/smart_collections'
    | '/library/trash'
    | '/media_sources/$mediaSourceId'
    | '/channels/$channelId/programming/add'
    | '/channels/$channelId/programming/slot-editor'
    | '/channels/$channelId/programming/time-slot-editor'
    | '/library/custom-shows/$showId/edit'
    | '/library/custom-shows/$showId/programming'
    | '/library/custom-shows/new/programming'
    | '/library/fillers/$fillerId/edit'
    | '/library/fillers/$fillerId/programming'
    | '/library/fillers/new/programming'
    | '/media_sources/$mediaSourceId/libraries/$libraryId'
    | '/channels/$channelId/edit'
    | '/channels/$channelId/programming'
    | '/library/custom-shows/new/'
    | '/library/fillers/new/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/guide'
    | '/search'
    | '/settings'
    | '/welcome'
    | '/channels/new'
    | '/channels/test'
    | '/library/custom-shows'
    | '/library/fillers'
    | '/settings/ffmpeg'
    | '/settings/general'
    | '/settings/hdhr'
    | '/settings/sources'
    | '/settings/xmltv'
    | '/system/debug'
    | '/system/logs'
    | '/system/tasks'
    | '/channels'
    | '/library'
    | '/media_sources'
    | '/system'
    | '/library/custom-shows/$showId'
    | '/library/fillers/$fillerId'
    | '/channels/$channelId/watch'
    | '/library/smart_collections/$id'
    | '/media/$programType/$programId'
    | '/settings/ffmpeg/$configId'
    | '/settings/ffmpeg/new'
    | '/channels/$channelId'
    | '/library/smart_collections'
    | '/library/trash'
    | '/media_sources/$mediaSourceId'
    | '/channels/$channelId/programming/add'
    | '/channels/$channelId/programming/slot-editor'
    | '/channels/$channelId/programming/time-slot-editor'
    | '/library/custom-shows/$showId/edit'
    | '/library/custom-shows/$showId/programming'
    | '/library/custom-shows/new/programming'
    | '/library/fillers/$fillerId/edit'
    | '/library/fillers/$fillerId/programming'
    | '/library/fillers/new/programming'
    | '/media_sources/$mediaSourceId/libraries/$libraryId'
    | '/channels/$channelId/edit'
    | '/channels/$channelId/programming'
    | '/library/custom-shows/new'
    | '/library/fillers/new';
  id:
    | '__root__'
    | '/'
    | '/guide'
    | '/search'
    | '/settings'
    | '/system'
    | '/welcome'
    | '/channels_/$channelId'
    | '/channels_/new'
    | '/channels_/test'
    | '/library/custom-shows'
    | '/library/fillers'
    | '/settings/ffmpeg'
    | '/settings/general'
    | '/settings/hdhr'
    | '/settings/sources'
    | '/settings/xmltv'
    | '/system/debug'
    | '/system/logs'
    | '/system/tasks'
    | '/channels_/'
    | '/library/'
    | '/media_sources_/'
    | '/system/'
    | '/library/custom-shows_/$showId'
    | '/library/custom-shows_/new'
    | '/library/fillers_/$fillerId'
    | '/library/fillers_/new'
    | '/channels_/$channelId/watch'
    | '/library/smart_collections/$id'
    | '/media_/$programType/$programId'
    | '/settings/ffmpeg_/$configId'
    | '/settings/ffmpeg_/new'
    | '/channels_/$channelId/'
    | '/library/smart_collections/'
    | '/library/trash_/'
    | '/media_sources_/$mediaSourceId/'
    | '/channels_/$channelId/programming/add'
    | '/channels_/$channelId/programming/slot-editor'
    | '/channels_/$channelId/programming/time-slot-editor'
    | '/library/custom-shows_/$showId/edit'
    | '/library/custom-shows_/$showId/programming'
    | '/library/custom-shows_/new/programming'
    | '/library/fillers_/$fillerId/edit'
    | '/library/fillers_/$fillerId/programming'
    | '/library/fillers_/new/programming'
    | '/media_sources_/$mediaSourceId/libraries_/$libraryId'
    | '/channels_/$channelId/edit/'
    | '/channels_/$channelId/programming/'
    | '/library/custom-shows_/new/'
    | '/library/fillers_/new/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  GuideRoute: typeof GuideRoute;
  SearchRoute: typeof SearchRoute;
  SettingsRoute: typeof SettingsRouteWithChildren;
  SystemRoute: typeof SystemRouteWithChildren;
  WelcomeRoute: typeof WelcomeRoute;
  ChannelsChannelIdRouteRoute: typeof ChannelsChannelIdRouteRouteWithChildren;
  ChannelsNewRoute: typeof ChannelsNewRoute;
  ChannelsTestRoute: typeof ChannelsTestRoute;
  LibraryCustomShowsRoute: typeof LibraryCustomShowsRoute;
  LibraryFillersRoute: typeof LibraryFillersRoute;
  ChannelsIndexRoute: typeof ChannelsIndexRoute;
  LibraryIndexRoute: typeof LibraryIndexRoute;
  Media_sourcesIndexRoute: typeof Media_sourcesIndexRoute;
  LibraryCustomShowsShowIdRouteRoute: typeof LibraryCustomShowsShowIdRouteRouteWithChildren;
  LibraryCustomShowsNewRouteRoute: typeof LibraryCustomShowsNewRouteRouteWithChildren;
  LibraryFillersFillerIdRouteRoute: typeof LibraryFillersFillerIdRouteRouteWithChildren;
  LibraryFillersNewRouteRoute: typeof LibraryFillersNewRouteRouteWithChildren;
  LibrarySmart_collectionsIdRoute: typeof LibrarySmart_collectionsIdRoute;
  MediaProgramTypeProgramIdRoute: typeof MediaProgramTypeProgramIdRoute;
  LibrarySmart_collectionsIndexRoute: typeof LibrarySmart_collectionsIndexRoute;
  LibraryTrashIndexRoute: typeof LibraryTrashIndexRoute;
  Media_sourcesMediaSourceIdIndexRoute: typeof Media_sourcesMediaSourceIdIndexRoute;
  Media_sourcesMediaSourceIdLibrariesLibraryIdRoute: typeof Media_sourcesMediaSourceIdLibrariesLibraryIdRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/welcome': {
      id: '/welcome';
      path: '/welcome';
      fullPath: '/welcome';
      preLoaderRoute: typeof WelcomeRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/system': {
      id: '/system';
      path: '/system';
      fullPath: '/system';
      preLoaderRoute: typeof SystemRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/settings': {
      id: '/settings';
      path: '/settings';
      fullPath: '/settings';
      preLoaderRoute: typeof SettingsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/search': {
      id: '/search';
      path: '/search';
      fullPath: '/search';
      preLoaderRoute: typeof SearchRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/guide': {
      id: '/guide';
      path: '/guide';
      fullPath: '/guide';
      preLoaderRoute: typeof GuideRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/system/': {
      id: '/system/';
      path: '/';
      fullPath: '/system/';
      preLoaderRoute: typeof SystemIndexRouteImport;
      parentRoute: typeof SystemRoute;
    };
    '/media_sources_/': {
      id: '/media_sources_/';
      path: '/media_sources';
      fullPath: '/media_sources';
      preLoaderRoute: typeof Media_sourcesIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/library/': {
      id: '/library/';
      path: '/library';
      fullPath: '/library';
      preLoaderRoute: typeof LibraryIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/channels_/': {
      id: '/channels_/';
      path: '/channels';
      fullPath: '/channels';
      preLoaderRoute: typeof ChannelsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/system/tasks': {
      id: '/system/tasks';
      path: '/tasks';
      fullPath: '/system/tasks';
      preLoaderRoute: typeof SystemTasksRouteImport;
      parentRoute: typeof SystemRoute;
    };
    '/system/logs': {
      id: '/system/logs';
      path: '/logs';
      fullPath: '/system/logs';
      preLoaderRoute: typeof SystemLogsRouteImport;
      parentRoute: typeof SystemRoute;
    };
    '/system/debug': {
      id: '/system/debug';
      path: '/debug';
      fullPath: '/system/debug';
      preLoaderRoute: typeof SystemDebugRouteImport;
      parentRoute: typeof SystemRoute;
    };
    '/settings/xmltv': {
      id: '/settings/xmltv';
      path: '/xmltv';
      fullPath: '/settings/xmltv';
      preLoaderRoute: typeof SettingsXmltvRouteImport;
      parentRoute: typeof SettingsRoute;
    };
    '/settings/sources': {
      id: '/settings/sources';
      path: '/sources';
      fullPath: '/settings/sources';
      preLoaderRoute: typeof SettingsSourcesRouteImport;
      parentRoute: typeof SettingsRoute;
    };
    '/settings/hdhr': {
      id: '/settings/hdhr';
      path: '/hdhr';
      fullPath: '/settings/hdhr';
      preLoaderRoute: typeof SettingsHdhrRouteImport;
      parentRoute: typeof SettingsRoute;
    };
    '/settings/general': {
      id: '/settings/general';
      path: '/general';
      fullPath: '/settings/general';
      preLoaderRoute: typeof SettingsGeneralRouteImport;
      parentRoute: typeof SettingsRoute;
    };
    '/settings/ffmpeg': {
      id: '/settings/ffmpeg';
      path: '/ffmpeg';
      fullPath: '/settings/ffmpeg';
      preLoaderRoute: typeof SettingsFfmpegRouteImport;
      parentRoute: typeof SettingsRoute;
    };
    '/library/fillers': {
      id: '/library/fillers';
      path: '/library/fillers';
      fullPath: '/library/fillers';
      preLoaderRoute: typeof LibraryFillersRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/library/custom-shows': {
      id: '/library/custom-shows';
      path: '/library/custom-shows';
      fullPath: '/library/custom-shows';
      preLoaderRoute: typeof LibraryCustomShowsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/channels_/test': {
      id: '/channels_/test';
      path: '/channels/test';
      fullPath: '/channels/test';
      preLoaderRoute: typeof ChannelsTestRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/channels_/new': {
      id: '/channels_/new';
      path: '/channels/new';
      fullPath: '/channels/new';
      preLoaderRoute: typeof ChannelsNewRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/channels_/$channelId': {
      id: '/channels_/$channelId';
      path: '/channels/$channelId';
      fullPath: '/channels/$channelId';
      preLoaderRoute: typeof ChannelsChannelIdRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/media_sources_/$mediaSourceId/': {
      id: '/media_sources_/$mediaSourceId/';
      path: '/media_sources/$mediaSourceId';
      fullPath: '/media_sources/$mediaSourceId';
      preLoaderRoute: typeof Media_sourcesMediaSourceIdIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/library/trash_/': {
      id: '/library/trash_/';
      path: '/library/trash';
      fullPath: '/library/trash';
      preLoaderRoute: typeof LibraryTrashIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/library/smart_collections/': {
      id: '/library/smart_collections/';
      path: '/library/smart_collections';
      fullPath: '/library/smart_collections';
      preLoaderRoute: typeof LibrarySmart_collectionsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/channels_/$channelId/': {
      id: '/channels_/$channelId/';
      path: '/';
      fullPath: '/channels/$channelId/';
      preLoaderRoute: typeof ChannelsChannelIdIndexRouteImport;
      parentRoute: typeof ChannelsChannelIdRouteRoute;
    };
    '/settings/ffmpeg_/new': {
      id: '/settings/ffmpeg_/new';
      path: '/ffmpeg/new';
      fullPath: '/settings/ffmpeg/new';
      preLoaderRoute: typeof SettingsFfmpegNewRouteImport;
      parentRoute: typeof SettingsRoute;
    };
    '/settings/ffmpeg_/$configId': {
      id: '/settings/ffmpeg_/$configId';
      path: '/ffmpeg/$configId';
      fullPath: '/settings/ffmpeg/$configId';
      preLoaderRoute: typeof SettingsFfmpegConfigIdRouteImport;
      parentRoute: typeof SettingsRoute;
    };
    '/media_/$programType/$programId': {
      id: '/media_/$programType/$programId';
      path: '/media/$programType/$programId';
      fullPath: '/media/$programType/$programId';
      preLoaderRoute: typeof MediaProgramTypeProgramIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/library/smart_collections/$id': {
      id: '/library/smart_collections/$id';
      path: '/library/smart_collections/$id';
      fullPath: '/library/smart_collections/$id';
      preLoaderRoute: typeof LibrarySmart_collectionsIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/channels_/$channelId/watch': {
      id: '/channels_/$channelId/watch';
      path: '/watch';
      fullPath: '/channels/$channelId/watch';
      preLoaderRoute: typeof ChannelsChannelIdWatchRouteImport;
      parentRoute: typeof ChannelsChannelIdRouteRoute;
    };
    '/library/fillers_/new': {
      id: '/library/fillers_/new';
      path: '/library/fillers/new';
      fullPath: '/library/fillers/new';
      preLoaderRoute: typeof LibraryFillersNewRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/library/fillers_/$fillerId': {
      id: '/library/fillers_/$fillerId';
      path: '/library/fillers/$fillerId';
      fullPath: '/library/fillers/$fillerId';
      preLoaderRoute: typeof LibraryFillersFillerIdRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/library/custom-shows_/new': {
      id: '/library/custom-shows_/new';
      path: '/library/custom-shows/new';
      fullPath: '/library/custom-shows/new';
      preLoaderRoute: typeof LibraryCustomShowsNewRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/library/custom-shows_/$showId': {
      id: '/library/custom-shows_/$showId';
      path: '/library/custom-shows/$showId';
      fullPath: '/library/custom-shows/$showId';
      preLoaderRoute: typeof LibraryCustomShowsShowIdRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/library/fillers_/new/': {
      id: '/library/fillers_/new/';
      path: '/';
      fullPath: '/library/fillers/new/';
      preLoaderRoute: typeof LibraryFillersNewIndexRouteImport;
      parentRoute: typeof LibraryFillersNewRouteRoute;
    };
    '/library/custom-shows_/new/': {
      id: '/library/custom-shows_/new/';
      path: '/';
      fullPath: '/library/custom-shows/new/';
      preLoaderRoute: typeof LibraryCustomShowsNewIndexRouteImport;
      parentRoute: typeof LibraryCustomShowsNewRouteRoute;
    };
    '/channels_/$channelId/programming/': {
      id: '/channels_/$channelId/programming/';
      path: '/programming';
      fullPath: '/channels/$channelId/programming';
      preLoaderRoute: typeof ChannelsChannelIdProgrammingIndexRouteImport;
      parentRoute: typeof ChannelsChannelIdRouteRoute;
    };
    '/channels_/$channelId/edit/': {
      id: '/channels_/$channelId/edit/';
      path: '/edit';
      fullPath: '/channels/$channelId/edit';
      preLoaderRoute: typeof ChannelsChannelIdEditIndexRouteImport;
      parentRoute: typeof ChannelsChannelIdRouteRoute;
    };
    '/media_sources_/$mediaSourceId/libraries_/$libraryId': {
      id: '/media_sources_/$mediaSourceId/libraries_/$libraryId';
      path: '/media_sources/$mediaSourceId/libraries/$libraryId';
      fullPath: '/media_sources/$mediaSourceId/libraries/$libraryId';
      preLoaderRoute: typeof Media_sourcesMediaSourceIdLibrariesLibraryIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/library/fillers_/new/programming': {
      id: '/library/fillers_/new/programming';
      path: '/programming';
      fullPath: '/library/fillers/new/programming';
      preLoaderRoute: typeof LibraryFillersNewProgrammingRouteImport;
      parentRoute: typeof LibraryFillersNewRouteRoute;
    };
    '/library/fillers_/$fillerId/programming': {
      id: '/library/fillers_/$fillerId/programming';
      path: '/programming';
      fullPath: '/library/fillers/$fillerId/programming';
      preLoaderRoute: typeof LibraryFillersFillerIdProgrammingRouteImport;
      parentRoute: typeof LibraryFillersFillerIdRouteRoute;
    };
    '/library/fillers_/$fillerId/edit': {
      id: '/library/fillers_/$fillerId/edit';
      path: '/edit';
      fullPath: '/library/fillers/$fillerId/edit';
      preLoaderRoute: typeof LibraryFillersFillerIdEditRouteImport;
      parentRoute: typeof LibraryFillersFillerIdRouteRoute;
    };
    '/library/custom-shows_/new/programming': {
      id: '/library/custom-shows_/new/programming';
      path: '/programming';
      fullPath: '/library/custom-shows/new/programming';
      preLoaderRoute: typeof LibraryCustomShowsNewProgrammingRouteImport;
      parentRoute: typeof LibraryCustomShowsNewRouteRoute;
    };
    '/library/custom-shows_/$showId/programming': {
      id: '/library/custom-shows_/$showId/programming';
      path: '/programming';
      fullPath: '/library/custom-shows/$showId/programming';
      preLoaderRoute: typeof LibraryCustomShowsShowIdProgrammingRouteImport;
      parentRoute: typeof LibraryCustomShowsShowIdRouteRoute;
    };
    '/library/custom-shows_/$showId/edit': {
      id: '/library/custom-shows_/$showId/edit';
      path: '/edit';
      fullPath: '/library/custom-shows/$showId/edit';
      preLoaderRoute: typeof LibraryCustomShowsShowIdEditRouteImport;
      parentRoute: typeof LibraryCustomShowsShowIdRouteRoute;
    };
    '/channels_/$channelId/programming/time-slot-editor': {
      id: '/channels_/$channelId/programming/time-slot-editor';
      path: '/programming/time-slot-editor';
      fullPath: '/channels/$channelId/programming/time-slot-editor';
      preLoaderRoute: typeof ChannelsChannelIdProgrammingTimeSlotEditorRouteImport;
      parentRoute: typeof ChannelsChannelIdRouteRoute;
    };
    '/channels_/$channelId/programming/slot-editor': {
      id: '/channels_/$channelId/programming/slot-editor';
      path: '/programming/slot-editor';
      fullPath: '/channels/$channelId/programming/slot-editor';
      preLoaderRoute: typeof ChannelsChannelIdProgrammingSlotEditorRouteImport;
      parentRoute: typeof ChannelsChannelIdRouteRoute;
    };
    '/channels_/$channelId/programming/add': {
      id: '/channels_/$channelId/programming/add';
      path: '/programming/add';
      fullPath: '/channels/$channelId/programming/add';
      preLoaderRoute: typeof ChannelsChannelIdProgrammingAddRouteImport;
      parentRoute: typeof ChannelsChannelIdRouteRoute;
    };
  }
}

interface SettingsRouteChildren {
  SettingsFfmpegRoute: typeof SettingsFfmpegRoute;
  SettingsGeneralRoute: typeof SettingsGeneralRoute;
  SettingsHdhrRoute: typeof SettingsHdhrRoute;
  SettingsSourcesRoute: typeof SettingsSourcesRoute;
  SettingsXmltvRoute: typeof SettingsXmltvRoute;
  SettingsFfmpegConfigIdRoute: typeof SettingsFfmpegConfigIdRoute;
  SettingsFfmpegNewRoute: typeof SettingsFfmpegNewRoute;
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsFfmpegRoute: SettingsFfmpegRoute,
  SettingsGeneralRoute: SettingsGeneralRoute,
  SettingsHdhrRoute: SettingsHdhrRoute,
  SettingsSourcesRoute: SettingsSourcesRoute,
  SettingsXmltvRoute: SettingsXmltvRoute,
  SettingsFfmpegConfigIdRoute: SettingsFfmpegConfigIdRoute,
  SettingsFfmpegNewRoute: SettingsFfmpegNewRoute,
};

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
);

interface SystemRouteChildren {
  SystemDebugRoute: typeof SystemDebugRoute;
  SystemLogsRoute: typeof SystemLogsRoute;
  SystemTasksRoute: typeof SystemTasksRoute;
  SystemIndexRoute: typeof SystemIndexRoute;
}

const SystemRouteChildren: SystemRouteChildren = {
  SystemDebugRoute: SystemDebugRoute,
  SystemLogsRoute: SystemLogsRoute,
  SystemTasksRoute: SystemTasksRoute,
  SystemIndexRoute: SystemIndexRoute,
};

const SystemRouteWithChildren =
  SystemRoute._addFileChildren(SystemRouteChildren);

interface ChannelsChannelIdRouteRouteChildren {
  ChannelsChannelIdWatchRoute: typeof ChannelsChannelIdWatchRoute;
  ChannelsChannelIdIndexRoute: typeof ChannelsChannelIdIndexRoute;
  ChannelsChannelIdProgrammingAddRoute: typeof ChannelsChannelIdProgrammingAddRoute;
  ChannelsChannelIdProgrammingSlotEditorRoute: typeof ChannelsChannelIdProgrammingSlotEditorRoute;
  ChannelsChannelIdProgrammingTimeSlotEditorRoute: typeof ChannelsChannelIdProgrammingTimeSlotEditorRoute;
  ChannelsChannelIdEditIndexRoute: typeof ChannelsChannelIdEditIndexRoute;
  ChannelsChannelIdProgrammingIndexRoute: typeof ChannelsChannelIdProgrammingIndexRoute;
}

const ChannelsChannelIdRouteRouteChildren: ChannelsChannelIdRouteRouteChildren =
  {
    ChannelsChannelIdWatchRoute: ChannelsChannelIdWatchRoute,
    ChannelsChannelIdIndexRoute: ChannelsChannelIdIndexRoute,
    ChannelsChannelIdProgrammingAddRoute: ChannelsChannelIdProgrammingAddRoute,
    ChannelsChannelIdProgrammingSlotEditorRoute:
      ChannelsChannelIdProgrammingSlotEditorRoute,
    ChannelsChannelIdProgrammingTimeSlotEditorRoute:
      ChannelsChannelIdProgrammingTimeSlotEditorRoute,
    ChannelsChannelIdEditIndexRoute: ChannelsChannelIdEditIndexRoute,
    ChannelsChannelIdProgrammingIndexRoute:
      ChannelsChannelIdProgrammingIndexRoute,
  };

const ChannelsChannelIdRouteRouteWithChildren =
  ChannelsChannelIdRouteRoute._addFileChildren(
    ChannelsChannelIdRouteRouteChildren,
  );

interface LibraryCustomShowsShowIdRouteRouteChildren {
  LibraryCustomShowsShowIdEditRoute: typeof LibraryCustomShowsShowIdEditRoute;
  LibraryCustomShowsShowIdProgrammingRoute: typeof LibraryCustomShowsShowIdProgrammingRoute;
}

const LibraryCustomShowsShowIdRouteRouteChildren: LibraryCustomShowsShowIdRouteRouteChildren =
  {
    LibraryCustomShowsShowIdEditRoute: LibraryCustomShowsShowIdEditRoute,
    LibraryCustomShowsShowIdProgrammingRoute:
      LibraryCustomShowsShowIdProgrammingRoute,
  };

const LibraryCustomShowsShowIdRouteRouteWithChildren =
  LibraryCustomShowsShowIdRouteRoute._addFileChildren(
    LibraryCustomShowsShowIdRouteRouteChildren,
  );

interface LibraryCustomShowsNewRouteRouteChildren {
  LibraryCustomShowsNewProgrammingRoute: typeof LibraryCustomShowsNewProgrammingRoute;
  LibraryCustomShowsNewIndexRoute: typeof LibraryCustomShowsNewIndexRoute;
}

const LibraryCustomShowsNewRouteRouteChildren: LibraryCustomShowsNewRouteRouteChildren =
  {
    LibraryCustomShowsNewProgrammingRoute:
      LibraryCustomShowsNewProgrammingRoute,
    LibraryCustomShowsNewIndexRoute: LibraryCustomShowsNewIndexRoute,
  };

const LibraryCustomShowsNewRouteRouteWithChildren =
  LibraryCustomShowsNewRouteRoute._addFileChildren(
    LibraryCustomShowsNewRouteRouteChildren,
  );

interface LibraryFillersFillerIdRouteRouteChildren {
  LibraryFillersFillerIdEditRoute: typeof LibraryFillersFillerIdEditRoute;
  LibraryFillersFillerIdProgrammingRoute: typeof LibraryFillersFillerIdProgrammingRoute;
}

const LibraryFillersFillerIdRouteRouteChildren: LibraryFillersFillerIdRouteRouteChildren =
  {
    LibraryFillersFillerIdEditRoute: LibraryFillersFillerIdEditRoute,
    LibraryFillersFillerIdProgrammingRoute:
      LibraryFillersFillerIdProgrammingRoute,
  };

const LibraryFillersFillerIdRouteRouteWithChildren =
  LibraryFillersFillerIdRouteRoute._addFileChildren(
    LibraryFillersFillerIdRouteRouteChildren,
  );

interface LibraryFillersNewRouteRouteChildren {
  LibraryFillersNewProgrammingRoute: typeof LibraryFillersNewProgrammingRoute;
  LibraryFillersNewIndexRoute: typeof LibraryFillersNewIndexRoute;
}

const LibraryFillersNewRouteRouteChildren: LibraryFillersNewRouteRouteChildren =
  {
    LibraryFillersNewProgrammingRoute: LibraryFillersNewProgrammingRoute,
    LibraryFillersNewIndexRoute: LibraryFillersNewIndexRoute,
  };

const LibraryFillersNewRouteRouteWithChildren =
  LibraryFillersNewRouteRoute._addFileChildren(
    LibraryFillersNewRouteRouteChildren,
  );

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  GuideRoute: GuideRoute,
  SearchRoute: SearchRoute,
  SettingsRoute: SettingsRouteWithChildren,
  SystemRoute: SystemRouteWithChildren,
  WelcomeRoute: WelcomeRoute,
  ChannelsChannelIdRouteRoute: ChannelsChannelIdRouteRouteWithChildren,
  ChannelsNewRoute: ChannelsNewRoute,
  ChannelsTestRoute: ChannelsTestRoute,
  LibraryCustomShowsRoute: LibraryCustomShowsRoute,
  LibraryFillersRoute: LibraryFillersRoute,
  ChannelsIndexRoute: ChannelsIndexRoute,
  LibraryIndexRoute: LibraryIndexRoute,
  Media_sourcesIndexRoute: Media_sourcesIndexRoute,
  LibraryCustomShowsShowIdRouteRoute:
    LibraryCustomShowsShowIdRouteRouteWithChildren,
  LibraryCustomShowsNewRouteRoute: LibraryCustomShowsNewRouteRouteWithChildren,
  LibraryFillersFillerIdRouteRoute:
    LibraryFillersFillerIdRouteRouteWithChildren,
  LibraryFillersNewRouteRoute: LibraryFillersNewRouteRouteWithChildren,
  LibrarySmart_collectionsIdRoute: LibrarySmart_collectionsIdRoute,
  MediaProgramTypeProgramIdRoute: MediaProgramTypeProgramIdRoute,
  LibrarySmart_collectionsIndexRoute: LibrarySmart_collectionsIndexRoute,
  LibraryTrashIndexRoute: LibraryTrashIndexRoute,
  Media_sourcesMediaSourceIdIndexRoute: Media_sourcesMediaSourceIdIndexRoute,
  Media_sourcesMediaSourceIdLibrariesLibraryIdRoute:
    Media_sourcesMediaSourceIdLibrariesLibraryIdRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
